import { render, staticRenderFns } from "./BillingAddres.vue?vue&type=template&id=84829458"
import script from "./BillingAddres.vue?vue&type=script&lang=js"
export * from "./BillingAddres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports